import { ModelInstance, ToFrontHook, ToBackHook, enumField, DateTimeField } from './util';

export enum FileEngine {
  django = 1,
  s3
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    original_name: 'originalName',
    path: 'path',
    resized_path: 'resizedPath',
    mime_type: 'mimeType',
    size: 'size',
    engine: 'engine',
    created_at: 'createdAt',
  },
  relation: {
    engine: enumField(FileEngine),
    createdAt: DateTimeField,
  }
})
export class File {
  id: number;
  name: string;
  _originalName: string;
  _path: string;
  resizedPath: string;
  mimeType: string;
  size: number;
  engine: FileEngine;
  createdAt: Date;

  set originalName(name: string) {
    this._originalName = name;
  }

  get originalName(): string {
    return this._originalName || this.name;
  }

  set path(filePath: string) {
    this._path = filePath;
  }

  get path(): string {
    return this.resizedPath || this._path;
  }

  @ToFrontHook
  static toFront(data: any): File {
    return null;
  }

  @ToBackHook
  static toBack(file: File): any {
    return null;
  }
}
